import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'tabs',

  type : 'module',
  
  label: 'Tabulations',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-tab',
  }
}